import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, Table } from 'reactstrap';
import './modalStyles.scss';

export default function GroupOperatorsModal() {
    const [isOpen, handleOpen] = useState(false);

    return (
        <React.Fragment>
            <div 
                onClick={() => handleOpen(true)} 
                className="info-line" 
                style={{ cursor: 'pointer', alignItems: 'center' }}
            >
                <i className="fa fa-info-circle" />
                <span>Advanced Search Operators</span>
            </div>

            <Modal style={{ height: '95vh' }} className="operators-modal" isOpen={isOpen} fade={false}>
                <ModalHeader toggle={() => handleOpen(!isOpen)}>
                    <strong>Search operators</strong>
                </ModalHeader>
                <ModalBody>
                    <Table className="search-operators-table" responsive>
                        <thead className="hidden">
                            <tr>
                                <th style={{ border: 'none' }}>Operator</th>
                                <th style={{ border: 'none' }}>Example</th>
                                <th style={{ border: 'none' }}>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="table_row">
                                <td className="table_column">
                                    <strong className="table_lable">Operator</strong>
                                    <div className="text-for-mobile">an exact word or phrase</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Example</strong>
                                    <div>"artificial intelligence"</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Description</strong>
                                    <div className="text-for-mobile">Containing the exact phrase "artificial intelligence".</div>
                                </td>
                            </tr>

                            <tr className="table_row">
                                <td className="table_column">
                                    <strong className="table_lable">Operator</strong>
                                    <div className="text-for-mobile">multiple words</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Example</strong>
                                    <div className="text-for-mobile">artificial AND intelligence</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Description</strong>
                                    <div className="text-for-mobile">Containing both "artificial" and "intelligence" but not necessarily as an exact phrase. The words can appear separately anywhere in the article.</div>
                                </td>
                            </tr>

                            <tr className="table_row">
                                <td className="table_column">
                                    <strong className="table_lable">Operator</strong>
                                    <div className="text-for-mobile">OR</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Example</strong>
                                    <div className="text-for-mobile">love OR hate</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Description</strong>
                                    <div className="text-for-mobile">Containing either "love" or "hate" (or both).</div>
                                </td>
                            </tr>

                            <tr className="table_row">
                                <td className="table_column">
                                    <strong className="table_lable">Operator</strong>
                                    <div className="text-for-mobile">grouping</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Example</strong>
                                    <div className="text-for-mobile">hotel AND (Boston OR "New York")</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Description</strong>
                                    <div className="text-for-mobile">Containing both "hotel" and either "Boston" or "New York".</div>
                                </td>
                            </tr>

                            <tr className="table_row">
                                <td className="table_column">
                                    <strong className="table_lable">Operator</strong>
                                    <div className="text-for-mobile">exclude</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Example</strong>
                                    <div className="text-for-mobile">"annual report" -filing</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Description</strong>
                                    <div className="text-for-mobile">Containing "annual report" but not "filing".</div>
                                </td>
                            </tr>

                            <tr className="table_row">
                                <td className="table_column">
                                    <strong className="table_lable">Operator</strong>
                                    <div className="text-for-mobile">exclude groups</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Example</strong>
                                    <div className="text-for-mobile">annual AND report -(filing OR stock)</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Description</strong>
                                    <div className="text-for-mobile">Containing both "annual" and "report" but not "filing" or "stock".</div>
                                </td>
                            </tr>

                            <tr className="table_row">
                                <td className="table_column">
                                    <strong className="table_lable">Operator</strong>
                                    <div className="text-for-mobile">exclude phrases</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Example</strong>
                                    <div className="text-for-mobile">social -"social media"</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Description</strong>
                                    <div className="text-for-mobile">Containing "social" anywhere in the message, but not "social media".</div>
                                </td>
                            </tr>

                            {/* <tr className="table_row">
                                <td className="table_column">
                                    <strong className="table_lable">Operator</strong>
                                    <div className="text-for-mobile">Search in Title only</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Example</strong>
                                    <div className="text-for-mobile">intitle:tesla</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Description</strong>
                                    <div className="text-for-mobile">
                                        Use intitle: in front of a keyword to limit your keyword search to only the headline. Results that only mention your keyword in the body will be excluded. <br/>
                                        Note: No space between intitle: and your keyword.
                                    </div>
                                </td>
                            </tr> */}
                        </tbody>
                    </Table>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
}
